import styled, {css} from "styled-components";
import {StickyNavigationMenuItemIconDefaultBox} from "./sticky-navigation-menu-item-icon.default.box";

export const StickyNavigationMenuItemIconSIBox = styled(StickyNavigationMenuItemIconDefaultBox)`
    ${(props) => props.isActive ? css`
        color: ${(props) => props.theme.colors.textLight};
    ` : null}
`;
